import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, commsHeader, indianProjectsBaseURL } from '../../../../Containers/Config/index.js';
import { SEND_COMMUNICATION, SEND_COMMUNICATION_SUCCESS, SEND_COMMUNICATION_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import cogoToast from 'cogo-toast';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* sendCommunication({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${indianProjectsBaseURL}/comms/send/communication`,
      method: 'POST',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
        ...commsHeader,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      cogoToast.success(response?.data?.message);
      yield put({
        type: SEND_COMMUNICATION_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: SEND_COMMUNICATION_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: SEND_COMMUNICATION_ERROR, payload: error });
  }
}

export function* watchSendCommunication() {
  yield takeEvery(SEND_COMMUNICATION, sendCommunication);
}

function* sendCommunicationSaga() {
  yield all([fork(watchSendCommunication)]);
}

export default sendCommunicationSaga;
